import { getOperationName } from '@apollo/client/utilities'
import { useToggle } from 'ahooks'
import { Form, Input, Modal } from 'antd'
import { FormInstance } from 'antd/lib/form'
import React from 'react'
import { useTranslation } from 'react-i18next'

import {
  GetWebsiteCategoriesDocument,
  WebsiteCategoryInfoFragment,
  useWebsiteCategoryAddMutation,
  useWebsiteCategoryUpdateMutation,
} from '@/generated/graphql'

const WebsiteCategoryCreataEditForm: React.FC<{
  form: FormInstance<any>
  websiteCategory?: WebsiteCategoryInfoFragment
}> = ({ form, websiteCategory }) => {
  const { t } = useTranslation()

  React.useEffect(() => {
    form.resetFields()
  }, [])

  const initialValues = {
    title: websiteCategory ? websiteCategory.title : '',
  }

  return (
    <>
      <Form
        form={form}
        initialValues={initialValues}
        labelCol={{ span: 4 }}
        wrapperCol={{ offset: 1 }}
        validateMessages={{
          required: t('group.createValidation'),
        }}
      >
        <Form.Item label={t('website.form.systemTitle')} name='title' rules={[{ required: true }]}>
          <Input />
        </Form.Item>
      </Form>
    </>
  )
}

export const WebsiteCategoryCreateEditModal: React.FC<{ websiteCategory?: WebsiteCategoryInfoFragment }> = ({
  websiteCategory,
  children,
  ...props
}) => {
  const { t } = useTranslation()
  const [form] = Form.useForm()
  const [visible, { toggle }] = useToggle()
  children = React.cloneElement(children as any, {
    ...props,
    onClick: () => toggle(),
  })

  const refetchQueries = {
    refetchQueries: [getOperationName(GetWebsiteCategoriesDocument)!],
  }

  const [websiteCategoryAdd] = useWebsiteCategoryAddMutation({
    ...refetchQueries,
  })

  const [websiteCategoryUpdate] = useWebsiteCategoryUpdateMutation({
    ...refetchQueries,
  })

  const onOK = async () => {
    const values = await form.validateFields()
    let res

    if (websiteCategory) {
      res = await websiteCategoryUpdate({
        variables: {
          websiteCategoryId: websiteCategory.websiteCategoryId,
          websiteCategoryUpdateInput: {
            title: values.title,
          },
        },
      })
    } else {
      res = await websiteCategoryAdd({
        variables: {
          websiteCategoryCreateInput: {
            title: values.title,
          },
        },
      })
    }

    if (!res.data) {
      return
    }

    toggle()
  }

  return (
    <>
      {children}
      <Modal
        title={t(`website.${!websiteCategory ? 'addCatalog' : 'updateCatalog'}`)}
        bodyStyle={{ padding: 40 }}
        maskClosable={false}
        visible={visible}
        onCancel={() => toggle()}
        onOk={() => onOK()}
        destroyOnClose
      >
        <WebsiteCategoryCreataEditForm form={form} websiteCategory={websiteCategory} />
      </Modal>
    </>
  )
}
